/** @format */

import { XIcon } from "@heroicons/react/solid";
import React from "react";
import { Link } from "react-router-dom";
import { removeSpaces } from "../../common/helpers/arrayHelpers";

import { getGenre } from "../../services/AnimeService";
import { AppDataContext } from "../../stateManagement/context/AppDataContext";
import { UiContext } from "../../stateManagement/context/UiContext";
import { SET_GENRE, TOGGLE_GENRE } from "../../stateManagement/variables";

export default function Genre() {
  const { dispatch } = React.useContext(UiContext);
  return (
    <div className="!z-50 fixed overflow-scroll custom-scroll px-5 h-screen w-[350px]  dark:bg-dark-800 rounded-lg bg-white ">
      <div className="flex flex-wrap flex-row">
        <XIcon
          onClick={() => dispatch({ type: TOGGLE_GENRE })}
          className="h-10 cursor-pointer  w-10 mt-3 mr-3 "
        />
        <p className="text-4xl  text-center font-windSong font-extralight p-2">
          Genre
        </p>
      </div>
      <hr />
      <RenderCategories />
    </div>
  );
}

function RenderCategories(props) {
  const { appData, dispatch } = React.useContext(AppDataContext);
  React.useEffect(() => {
    if (appData.isLoaded.value && appData.isLoaded.time > Date.now() - 300000)
      return;
    async function resolver() {
      let res = await getGenre();
      dispatch({ type: SET_GENRE, payload: res.data });
    }
    resolver();
    // eslint-disable-next-line
  }, []);

  const handelRandomClick = () => {
    //getting a random value from genre array.
    if (!appData.genre) return;
    let gen =
      appData.genre[Math.ceil(Math.random() * parseInt(appData.genre.length))];
    window.location.href = `/genre/${gen.id}/genre=${removeSpaces(gen.title)}`;
  };

  return (
    <div className=" overflow-scroll custom-scroll flex mt-5 flex-wrap flex-row gap-5  ">
      <div
        onClick={handelRandomClick}
        className="cursor-pointer shadow-md  dark:shadow-inner font-montserrat text-center font-semibold  h-36 w-36 grid place-items-center  duration-200 px-3 py-5 rounded-2xl dark:text-white text-lg d bg-red-500 text-black  "
      >
        Random
      </div>

      {appData.genre &&
        appData.genre.map((item) => (
          <Link
            to={`/genre/${item.id}/genre=${removeSpaces(item.title)}`}
            key={item.id}
            className="shadow-md dark:shadow-inner hover:shadow-lg font-montserrat text-center font-semibold  h-36 w-36 grid place-items-center  duration-200 px-3 py-5 rounded-2xl dark:text-white text-lg dark:bg-dark-100 bg-gray-100 text-black  "
          >
            {item.title}
          </Link>
        ))}
    </div>
  );
}
